import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';

Bugsnag.start({
    apiKey: import.meta.env.VUE_APP_BUGSNAG_KEY,
    plugins: [new BugsnagPluginVue()],
    releaseStage: import.meta.env.VUE_APP_ENV,
    // Generated & Provided by Netlify's DEPLOY_ID
    appVersion: _APP_VERSION_
});

export function setBugsnagUser(authUser) {
    if (authUser && authUser.sub) {
        Bugsnag.setUser(authUser.sub, authUser.email, authUser.name || undefined);
        Bugsnag.addMetadata('auth0', {
            email: authUser.email,
            name: authUser.name,
            ...authUser,
        });
    }
}

export default Bugsnag;
